export default __webpack_public_path__ + "static/media/land-of-dreams.71a3438c.jpg";